class Core {
    constructor() {
        this.currentTimeout = null;
    };
    
    wait(timeout) {
        if (this.currentTimeout) {
            clearTimeout(this.currentTimeout);
        };
        return new Promise(resolve => {
            this.currentTimeout = setTimeout(resolve, timeout);
        });
    };
};
window.addEventListener("load", function () {
    // change background khi click quay 10
  
    const dndPromotion = window.libraryMainsite.promotion;
    
    const core = new Core();
    
    // Cache jQuery selector
    const $items = $(".gr_effect--item");
    const totalItems = $items.length;
    
    // Set random animation delay and duration for each item to create natural bubble effect
    $items.each(function() {
        const $img = $(this).find("img");
        const randomDelay = Math.random() * 1.5; // Random delay from 0 to 1.5 seconds
        const randomDuration = 1.5 + Math.random() * 1; // Random duration from 1.5 to 2.5 seconds
        $img.css({
            "animation-delay": randomDelay + "s",
            "animation-duration": randomDuration + "s"
        });
    });
    
    // Animation timing constants
    const LOOP_DELAY = 150;
    const FINAL_DELAY = 280;
    const CLEANUP_DELAY = 100;
    const RANDOM_LOOPS = 10; // Số lần random active
    
    // Function to calculate animation duration based on prizeIndex
    function calculateAnimationTime(prizeIndex) {
        const randomTime = RANDOM_LOOPS * LOOP_DELAY;
        return randomTime + CLEANUP_DELAY;
    }
    
    async function animationRandom(prizeIndex) {
        const targetIndex = prizeIndex - 1;
        
        $items.removeClass("active");
        
        // Random active 10 lần
        let previousIndex = -1;
        for (let loop = 0; loop < RANDOM_LOOPS; loop++) {
            // Random một index khác với index trước đó
            let randomIndex;
            do {
                randomIndex = Math.floor(Math.random() * totalItems);
            } while (randomIndex === previousIndex && totalItems > 1);
            
            // Remove active từ item trước
            if (previousIndex >= 0) {
                $items.eq(previousIndex).removeClass("active");
            }
            
            // Active item random
            $items.eq(randomIndex).addClass("active");
            await core.wait(LOOP_DELAY);
            
            previousIndex = randomIndex;
        }
        
        // Remove active từ item cuối cùng của random
        if (previousIndex >= 0) {
            $items.eq(previousIndex).removeClass("active");
        }
        
        // Active item tại prizeIndex và dừng lại
        $items.eq(targetIndex).addClass("active");
        
        setTimeout(() => {
            $items.removeClass("active");
        }, CLEANUP_DELAY);
    }

    // Create config object that can be updated dynamically
    const promotionConfig = {
        timeWait: 3000 // Default value, will be updated dynamically
    };

    dndPromotion({
        url: prodTemplate.url,
        debug: prodTemplate.debug,
        directory: prodTemplate.directory,
        items: prodTemplate.items,
        names: prodTemplate.names,
        config: promotionConfig,
        animResult: function (listPrize) {
            const prizeIndex = listPrize[0].indexImg;
            
            // Calculate and update timeWait based on animation duration
            promotionConfig.timeWait = calculateAnimationTime(prizeIndex); 
            console.log("timeWait: " + promotionConfig.timeWait);
            animationRandom(prizeIndex);
        },
        callback: function () {
            if (typeof prodTemplate.fnPromotion === "function") {
                prodTemplate.fnPromotion();
            }
        },
    });
});
